import { Box, Typography } from '@mui/material';
import { MiniDrawerWithContext } from 'components/Layout/drawer';
import { useTitle } from 'components/utilities/hooks/useTitle';
import { useActionButtonsStyles } from 'components/pages/AppLibrary/styles';
import { CompletedSlidesButton } from 'components/pages/AppLibrary/components/CompletedSlidesButton';
import { ProcessingButton } from 'components/pages/AppLibrary/components/ProcessingButton';
import { useState } from 'react';
import { FILTER_BUTTONS } from 'components/pages/AppLibrary/constants';
import { AiToolsButton } from 'components/pages/AppLibrary/components/AiToolsButton';
import { FilteredSlides } from 'components/pages/AppLibrary/FilteredSlides';
import { AITools } from 'components/pages/AppLibrary/AITools';
import { useAppLibraryHomeStyles } from 'components/pages/AppLibrary/HomePage/styles';
import { getLocalToken } from 'utilities/token';
import { useAuth0 } from '@auth0/auth0-react';

export const AppLibrary = () => {
  useTitle('HistoWiz - App Library');
  const { isAuthenticated } = useAuth0();
  const isLoggedIn = !!getLocalToken() || isAuthenticated;

  const { classes } = useAppLibraryHomeStyles();
  const { classes: buttonClasses } = useActionButtonsStyles();

  const [activeFilter, setActiveFilter] = useState(FILTER_BUTTONS.aiTools);
  // const [sort, setSort] = useState(SELECT_SORT_OPTIONS.mostMatches);

  // const sortHandler = (event) => {
  //   setSort(event.target.value);
  // };

  const activeFilterHandler = (currentButton) => {
    if (currentButton === activeFilter) return;
    setActiveFilter(currentButton);
  };

  const getButtonClasses = (currentButton) =>
    currentButton === activeFilter
      ? `${buttonClasses.button} ${buttonClasses.activeButton}`
      : buttonClasses.button;

  const getHeaderTitle = () => {
    switch (activeFilter) {
      case FILTER_BUTTONS.aiTools:
        return 'TOOLS';
      case FILTER_BUTTONS.completed:
        return 'COMPLETED SLIDES';
      case FILTER_BUTTONS.processing:
        return 'IN-PROCESSING';
      default:
        return '';
    }
  };

  return (
    <MiniDrawerWithContext header="App Library">
      <Box className={classes.root}>
        <Box className={classes.titleWrapper}>
          <Typography className={classes.title}>
            AI APP LIBRARY: {getHeaderTitle()}
          </Typography>
          {/* TODO: uncomment when feature will be ready */}

          {/* <Box>
            <span>SORT BY:</span>
            <Select
              value={sort}
              variant="outlined"
              className={classes.select}
              onChange={sortHandler}
            >
              <MenuItem value={SELECT_SORT_OPTIONS.latest}>
                Latest (Modified)
              </MenuItem>
              <MenuItem value={SELECT_SORT_OPTIONS.mostMatches}>
                Most matches
              </MenuItem>
              <MenuItem value={SELECT_SORT_OPTIONS.oldest}>Oldest</MenuItem>
            </Select>
          </Box> */}
        </Box>

        {isLoggedIn && (
          <Box className={classes.buttonsWrapper}>
            <AiToolsButton
              onClick={() => activeFilterHandler(FILTER_BUTTONS.aiTools)}
              className={getButtonClasses(FILTER_BUTTONS.aiTools)}
            />
            <CompletedSlidesButton
              onClick={() => activeFilterHandler(FILTER_BUTTONS.completed)}
              className={getButtonClasses(FILTER_BUTTONS.completed)}
            />
            <ProcessingButton
              onClick={() => activeFilterHandler(FILTER_BUTTONS.processing)}
              className={getButtonClasses(FILTER_BUTTONS.processing)}
            />
          </Box>
        )}
        {activeFilter === FILTER_BUTTONS.aiTools ? (
          <AITools />
        ) : (
          <FilteredSlides activeFilter={activeFilter} isAppLibrary />
        )}
      </Box>
    </MiniDrawerWithContext>
  );
};
